import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, TextField, Typography } from '@mui/material';
import SimpleNavbar from '../components/common/SimpleNavbar';

const PASSWORD = 'pitchdeck'; // Simple demo password

function LoginPage() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === PASSWORD) {
      localStorage.setItem('isAuthenticated', 'true');
      window.location.reload();
    } else {
      setError('Incorrect password');
    }
  };

  return (
    <>
      <SimpleNavbar />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          height: 'calc(100vh - 64px)',
          pt: 4,
        }}
      >
      <Box sx={{ textAlign: 'center', mb: 3 }}>
        <Typography variant="h2" component="h1" gutterBottom>
          Pitch Deck Analyzer
        </Typography>
        <Typography variant="h5" color="text.secondary" paragraph>
          Analyze any pitch deck with AI-powered technology
        </Typography>
      </Box>
      <Typography variant="h4" component="h2" sx={{ mb: 3 }}>
        Please Log In
      </Typography>
      <Box
        component="form"
        onSubmit={handleLogin}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          width: 300,
        }}
      >
        <TextField
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          error={!!error}
          helperText={error}
          fullWidth
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
        >
          Login
        </Button>
      </Box>
      </Box>
    </>
  );
}

export default LoginPage;
